import {
  WEBCHAT_TRACKING_FIELDS,
  WEBCHAT_VISITOR_IDENTIFIER_PREFIX,
} from 'modules/webchat/domain/constants';
import {
  IWebchatIdentity,
  IWebchatTracking,
} from 'modules/webchat/domain/entities';

const VISITOR_IDENTIFIER_PATTERN = new RegExp(
  `^${WEBCHAT_VISITOR_IDENTIFIER_PREFIX}[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$`,
  'i',
);
const E164_PHONE_PATTERN = /^\+[1-9]\d{7,14}$/;
/** Limite de cada campo de origem, para um valor editado no navegador não ir inteiro para a Callbell. */
const TRACKING_VALUE_MAX_LENGTH = 500;

/** Fica só com os campos de origem conhecidos, em texto e aparados. */
const parseTracking = (value: unknown): IWebchatTracking | undefined => {
  if (typeof value !== 'object' || value === null) return undefined;

  const source = value as Record<string, unknown>;
  const tracking: IWebchatTracking = {};

  (
    Object.keys(WEBCHAT_TRACKING_FIELDS) as Array<keyof IWebchatTracking>
  ).forEach(key => {
    const field = source[key];

    if (typeof field !== 'string' || !field.trim()) return;

    tracking[key] = field.trim().slice(0, TRACKING_VALUE_MAX_LENGTH);
  });

  return Object.keys(tracking).length > 0 ? tracking : undefined;
};

/**
 * Aceita só a identidade que o pré-chat monta (buildVisitorWebchatIdentity):
 * identifier visitante-<uuid v4>, nome, celular E.164 e a origem do clique. O resultado nunca leva customerId, para que um valor editado no
 * navegador não apareça ao atendente como um cliente do Vectis. Qualquer
 * outra coisa devolve null.
 */
export default function parseVisitorWebchatIdentity(
  value: unknown,
): IWebchatIdentity | null {
  if (typeof value !== 'object' || value === null) return null;

  const { identifier, name, phone, tracking } = value as Record<
    string,
    unknown
  >;

  if (
    typeof identifier !== 'string' ||
    !VISITOR_IDENTIFIER_PATTERN.test(identifier) ||
    typeof name !== 'string' ||
    !name.trim() ||
    typeof phone !== 'string' ||
    !E164_PHONE_PATTERN.test(phone)
  ) {
    return null;
  }

  const parsedTracking = parseTracking(tracking);

  return {
    identifier,
    name: name.trim(),
    phone,
    ...(parsedTracking ? { tracking: parsedTracking } : {}),
  };
}
